import React from "react";
import PropTypes from "prop-types";

import { CAMPAIGN_TYPE } from "../../../constants";

import "./style.css";

function Logo({ title, subTitle, logoPath, campaignType }) {
  if(!title && !subTitle && !logoPath) {
    return <div id="splash-spacer" />;
  }

  return (
    <div className="splash-logoRow">
      {(title || subTitle) && (
        <div className="splash-title">
          {title && <p className="name">{title}</p>}
          {subTitle && <p>{subTitle}</p>}
        </div>
      )}
      {logoPath && (
        <div className="splash-image-container" >
          <img className={`splash-image ${campaignType === CAMPAIGN_TYPE.PERSONALIZED.value ? 'full-widht' : ''}`} alt={`${title} logo`} src={logoPath} />
        </div>
      )}
    </div>
  );
}

Logo.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  logoPath: PropTypes.string.isRequired,
};

Logo.defaultProps = {
  title: '',
  subTitle: '',
  logoPath: '',
}

export default Logo;



// WEBPACK FOOTER //
// ./src/containers/Splash/Logo/index.jsx